import axios from '../../../service/index'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { Button, Divider, message, Form, Input, Transfer, Switch, Upload } from 'antd'
import E from 'wangeditor'
import './addExcellentCourse.less'

const qiniuUpUrl = 'https://up-z1.qiniup.com'
const FormItem = Form.Item
class addExcellentCourse extends Component {
	constructor(props) {
		super(props)
		this.state = {
			courseType: sessionStorage.getItem('courseType'),
			qiuniuUrl: '',
			strageId: '',
			visible: false,
			releaseVisible: false,
			strageName: '',
			changeSwitch: false,
			mockData: [],
			targetKeys: [],
			editor: '',
			editorHtml: '',
			editorText: '',
			details: null,
			hot: '',
			label: '',
			name: '',
			poster: {},
			introduce: '',
			fileList: [],
			editList: [],
			disabled: false
		}
	}

	componentDidMount() {
		this.getToken()
		let editor = new E(ReactDOM.findDOMNode(this._div))
		this.setState({ editor: editor })
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'redo',
			'image',
		]
		editor.config.uploadImgMaxLength = 5;
		editor.config.showLinkImg = false;
		editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		editor.config.withCredentials = false;
		editor.config.uploadImgTimeout = 5 * 1000;
		// editor.customConfig.zIndex = 100;
		let _this = this
		editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			let imgUrl = ''
			let data = new FormData();
			data.append("token", _this.state.token);
			data.append("file", resultFiles[0]);
			axios({
				method: "POST",
				url: qiniuUpUrl,
				data: data,
				onUploadProgress: function (progressEvent) {
					//    var percentCompleted = Math.round(
					// 	   (progressEvent.loaded * 100) /
					// 	   progressEvent.total
					//    );
				},
			}).then((res) => {
				imgUrl = _this.state.url + '/' + res.data.key
				insertImgFn(imgUrl);
			});
		};
		editor.config.onchange = (html) => {
			this.setState({
				editorHtml: html,
				editorText: editor.txt.text()
			})
			//将html值设为form表单的desc属性值
			this.props.form.setFieldsValue({
				'introduce': html
			});
		}
		editor.create()
		this.getLableList()
		this.props.form.setFieldsValue({
			'switch': false
		})
	}
	validateEditorFrom = (rule, value, callback) => {
		// console.log(this.state.editorText)
		if (this.state.editorHtml.trim() === '') {
			callback('不能为空');
		}
		callback();
	}
	async getLableList() {
		axios.post('labelController/getOption').then(res => {
			if (res.data.code === '200') {
				let arr = res.data.data
				// const targetKeys = [];
				const mockData = [];
				for (let i = 0; i < arr.length; i++) {
					const data = {
						key: arr[i].id,
						title: arr[i].name,
					};
					mockData.push(data);
				}
				this.setState({ mockData: mockData },()=>{
					this.getCourseDetail()
				});
			}
		})
	}
	getCourseDetail() {
		if (this.state.courseType === 'modify') {
			let id = sessionStorage.getItem('courseId')
			axios.get(`courseController/get/${id}`).then(res => {
				if (res.data.code === '200') {
					let details = res.data.data
					this.setState({ details: details, editorHtml: details.introduce,editList: [{ url: details.poster, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', type: 'image/*', name: details.name }],fileList: [{ url: details.poster, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', type: 'image/*', name: details.name }] })
					this.state.editor.txt.html(details.introduce)
					this.props.form.setFieldsValue({
						'poster': this.state.fileList,
						'switch': details.hot === 0 ? false : true 
					})
					if (details.label && details.label) {
						let label = details.label.split(';')
						let mockData = []
						let targetKeys = []
						for (let j = 0; j < this.state.mockData.length; j++) {
							for (let i = 0; i < label.length; i++) {
								if (label[i] === this.state.mockData[j].title) {
									targetKeys.push(this.state.mockData[j].key)
								}
							}
							mockData.push(this.state.mockData[j])
						}
						this.setState({ mockData: mockData, targetKeys: targetKeys })
					}
				}
			})
		}
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			// console.log(values)
			if (!err) {
				let lable = []
				for (let j = 0; j < this.state.mockData.length; j++) {
					for (let i = 0; i < values.lable.length; i++) {
						if (values.lable[i] === this.state.mockData[j].key) {
							lable.push(this.state.mockData[j].title)
						}
					}
				} 
				let params = {
					subjectId: sessionStorage.getItem('subjectId'),
					// stageId: sessionStorage.getItem('stageId'),
					name: values.name,
					introduce: values.introduce,
					type: 3,
					hot: values.switch === true ? 1 : 0,
					prenum: values.prenum,
					label: !lable ? '' : lable.join(';'),
					poster: this.state.courseType === 'modify' ? JSON.stringify(this.state.editList) === JSON.stringify(this.state.fileList)? values.poster[0].url: this.state.url + '/' + values.poster[0].response.key :this.state.url + '/' + values.poster[0].response.key,
					id: this.state.courseType === 'modify' ? sessionStorage.getItem('courseId') : ''
				}
				console.log(params)
				let url = this.state.courseType === 'modify' ? 'courseController/update' : 'courseController/add'
				axios.post(url, params).then(res => {
					if (res.data.code === '200') {
						if(this.state.courseType === 'modify'){
							message.success('编辑精品课成功')
						}else {
							message.success('添加精品课成功')
						}
						this.props.history.push('/ExcellentCourse')
					}else {
						message.error(res.data.msg)
					}
				})
			}

		});
	}
	filterOption = (inputValue, option) => option.title.indexOf(inputValue) > -1;;

	handleChange = targetKeys => {
		this.setState({ targetKeys });
	};

	handleSearch = (dir, value) => {
		// console.log('search:', dir, value);
	};
	handleSelectChange = () => {

	}
	getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	normFile = e => {
		if (e.fileList.length === 2) {
			e.fileList = e.fileList.slice(-1);
			message.warning("一个版本只能上传一个文件")
		};
		if (Array.isArray(e)) {
			
			return e;
		}
		return e && e.fileList;
	};
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
		});
	}
	handleChangefile = ({ file, fileList }) => {
		if (file.percent === 100) {
			if (file.status === 'done') {
				let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: this.state.url + '/' + fileList[0].response.hash,
					type: fileList[0].type
				}
				this.setState({ fileList: fileL });

			}
		}
		else if (file.status === 'removed') {
			this.setState({ fileList: [] });
		}
	};
	showModal() {
		this.setState({ visible: true })
	}
	render() {
		const { courseType, details, mockData, targetKeys } = this.state;
		const { getFieldDecorator } = this.props.form;
		const uploadButton = (
			<div>
				<Button>上传封面</Button>
				<p style={{ fontSize: '12px', color: '#99999', marginTop: '12px' }}>仅支持jpg/png/jpeg文件，且不超过2M,建议尺寸：750*426px</p>
			</div>
		);
		return (
			<div className="addCourse">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>{courseType === 'modify' ? '编辑课程' : '新增课程'}</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.push('/ExcellentCourse')
					}}>返回上一级</span>
				</div>
				<Divider />
				<Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.handleSubmit}>
					<FormItem label={"课程名称"}>
						{getFieldDecorator('name', {
							rules: [{ required: true, message: '请输入课程名称!', }],
							initialValue: courseType === 'modify' && details ? details.name : ''
						})(
							<Input maxLength={50} style={{ height: '40px' }} placeholder='请输入课程名称' />
						)}
					</FormItem>
					<Form.Item label="课程封面">
						{getFieldDecorator('poster', {
							rules: [{ required: true, message: '请上传课程封面!', }],
							valuePropName: 'fileList',
							getValueFromEvent: this.normFile,
						})(
							<Upload
								accept=".png,.jpg"
								action={qiniuUpUrl}
								listType='picture'
								disabled={this.state.disabled}
								beforeUpload={(file, fileList) => {
									const isLt10M = file.size / 1024 / 1024 <= 2;
									if (!isLt10M) {
										message.error("文件大小限制在2M以下！");
										return false;
									}
								}}
								onChange={this.handleChangefile}
								data={{ token: this.state.token }}>
									{uploadButton}
								{/* {this.state.fileList.length >= 1 ? '' : uploadButton} */}
							</Upload>
						)}
					</Form.Item>
					
					<FormItem label={"选择标签"}>
						{getFieldDecorator('lable', {
							rules: [{ required: true, message: '请选择标签', }],
							initialValue: courseType === 'modify' && details ? targetKeys : ''
						})(
							<Transfer
								dataSource={mockData}
								showSearch
								filterOption={this.filterOption}
								targetKeys={this.state.targetKeys}
								onChange={this.handleChange}
								onSearch={this.handleSearch}
								render={item => item.title}
							/>
						)}
					</FormItem>
					<FormItem label={"是否热门"}>
						{getFieldDecorator('switch', {
							valuePropName: 'checked',
							rules: [{ required: true, message: '请选择是否是热门!', }]
						})(
							<Switch />
						)}
					</FormItem>
					<FormItem label={"预设学习人数"}>
						{getFieldDecorator('prenum', {
							initialValue: courseType === 'modify' && details ? details.prenum : ''
						})(
							<Input placeholder='请输入预设学习人数' type="number" />
						)}
					</FormItem>
					<FormItem label={"课程简介"}>
						{getFieldDecorator('introduce', {
							rules: [{ required: true, message: '请输入课程简介!', }, { validator: this.validateEditorFrom }],
							initialValue: this.state.courseType === 'modify' && this.state.details ? details.poster : ''
						})(
							<div ref={(ref) => this._div = ref}></div>

						)}
					</FormItem>
					<FormItem >
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button type="primary" style={{ marginRight: '30px' }} onClick={() => {
								this.props.history.push('/ExcellentCourse')
							}}>取消</Button>
							<Button type="primary" htmlType="submit">确定</Button>
						</div>
					</FormItem>
				</Form>

			</div>
		)
	}
}

export default Form.create({ name: 'validate_other' })(addExcellentCourse)